import { useApp } from '../context';
import { navigate } from '../router';
import { Card, TopBar } from '../components/ui';

export function More({ onSignOut }: { onSignOut: () => void }) {
  const { session } = useApp();
  const items = [
    { to: '/award', label: 'Award points', sub: 'Reward safe work you observed' },
    { to: '/rules', label: 'Reward rules & drawing types', sub: 'Point values, caps, thresholds, required forms' },
    { to: '/crews', label: 'Crews', sub: 'Which foremen show on the crew board' },
    { to: '/audit', label: 'Audit log', sub: 'Every award, change, drawing and export' },
    { to: '/integration', label: 'Connecteam integration', sub: 'Sync, reconciliation, inbound events' },
  ];
  return (
    <div className="page">
      <TopBar title="More" />
      <Card>
        {items.map((i) => (
          <button key={i.to} className="list-row" onClick={() => navigate(i.to)}>
            <div><strong>{i.label}</strong><div className="muted small">{i.sub}</div></div><span className="chev">›</span>
          </button>
        ))}
      </Card>
      <Card>
        <div className="muted small">Signed in as</div>
        <div><strong>{session.name}</strong></div>
        <div className="muted small">{session.user}</div>
        <button className="btn btn-secondary btn-block mt" onClick={onSignOut}>Sign out</button>
      </Card>
      <p className="muted small center">KES Safety Accountability Program • {import.meta.env.VITE_APP_VERSION || 'dev'}</p>
    </div>
  );
}
